import axios from 'axios';
import type { UnsplashSearchResponse } from './types';
import { configSettings } from '@/lib/config';

const clientId = configSettings.unsplashApiClientId;

/**
 * Search Unsplash images
 */
export async function searchUnsplashImages(
    query: string,
    pageNum: number = 1,
    perPage: number = 30
): Promise<UnsplashSearchResponse> {
    const url = `https://api.unsplash.com/search/photos/?client_id=${clientId}&query=${query}&page=${pageNum}&per_page=${perPage}`;
    const response = await axios.get<UnsplashSearchResponse>(url);
    return response.data;
}

/**
 * Get's downloadable image url from unsplash
 */
export async function getUnsplashImageAPICompliance(imageLocationURL: string): Promise<string> {
    const url = `${imageLocationURL}?client_id=${clientId}`;
    const response = await axios.get<{ url: string }>(url);
    return response.data.url;
}
